import React from 'react'
import PropTypes from 'prop-types'
import { Box, TextField, Typography, Paper } from '@mui/material'
import { Controller } from 'react-hook-form'
import T from 'T'
import RichTextEditor from '../RichTextEditor'

const EmailForm = ({ control, errors }) => {
  return (
    <>
      <Box mb={2}>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          {T.SUBJECT_TITLE}
        </Typography>
        <Controller
          name="subject"
          control={control}
          rules={{ required: T.SUBJECT_REQUIRED }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              size="small"
              placeholder={T.ENTER_SUBJECT}
              error={!!errors.subject}
              helperText={errors.subject?.message}
            />
          )}
        />
      </Box>

      <Box mb={2}>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          {T.EMAIL_BODY}
        </Typography>
        <Controller
          name="body"
          control={control}
          rules={{ required: T.EMAIL_BODY_REQUIRED }}
          render={({ field }) => (
            <Paper variant="outlined" sx={{ ...(errors.body && { borderColor: 'error.main' }) }}>
              <RichTextEditor value={field.value} onChange={field.onChange} />
              {errors.body && (
                <Typography variant="caption" color="error" sx={{ px: 2, pb: 1, display: 'block' }}>
                  {errors.body.message}
                </Typography>
              )}
            </Paper>
          )}
        />
      </Box>
    </>
  )
}

EmailForm.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
}

export default EmailForm
